import type { SxProps, Theme } from "@mui/material/styles";

/** Compact Microsoft-style field density for right-drawer forms. */
export const DRAWER_FORM_GRID_SPACING = 1.5;

export const dialogFormLayoutSx: SxProps<Theme> = {
  width: "100%",
  minWidth: 0,
  p: 0,
  display: "flex",
  flexDirection: "column",
  gap: 2,
  overflow: "visible",
  "& .MuiOutlinedInput-root, & .MuiPickersOutlinedInput-root": {
    borderRadius: "4px",
  },
  "& .MuiFormControl-root": {
    width: "100%",
    minWidth: 0,
  },
  "& .MuiAutocomplete-root": {
    width: "100%",
    minWidth: 0,
  },
  "& .MuiGrid-container": {
    width: "100%",
  },
  "& .MuiGrid-container > .MuiGrid-root": {
    minWidth: 0,
  },
  "& .MuiFormHelperText-root": {
    mx: 0,
    mt: 0.5,
    lineHeight: 1.35,
  },
};

export const drawerReadonlyFieldSx: SxProps<Theme> = {
  "& .MuiOutlinedInput-root": {
    backgroundColor: ({ palette }) => palette.background.sectionAlt,
  },
};
